var _defs, _polygon, _polygon2, _polygon3, _polygon4, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRohrgefuehrteMedienLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Aufbau",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 644.6 152.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Unbenannter_Verlauf);}.cls-2{fill:url(#Unbenannter_Verlauf_2);}.cls-3{fill:url(#Unbenannter_Verlauf_4);}.cls-4{fill:url(#Unbenannter_Verlauf_5);}.cls-5{fill:#014187;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf",
    cx: -74.86,
    cy: 632.8,
    r: 1.04,
    gradientTransform: "matrix(-159.41, 0, 0, 162, -11799.25, -102485.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#014187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#014187"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_2",
    cx: -74.77,
    cy: 632.8,
    r: 1.08,
    gradientTransform: "matrix(-215.06, 0, 0, 218.55, -15960.67, -138099.37)",
    xlinkHref: "#Unbenannter_Verlauf"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_4",
    cx: -74.76,
    cy: 632.8,
    r: 1.1,
    gradientTransform: "matrix(-215.05, 0, 0, 218.54, -15960.48, -138092.17)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#bac503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#bac503"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_5",
    cx: -74.87,
    cy: 632.8,
    r: 1.04,
    gradientTransform: "matrix(-159.41, 0, 0, 162, -11799.71, -102485.72)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bac503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#bac503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bac503"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Infraserv_Gendorf_Logo_rgb") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "222.7 1.13 46.7 120.53 126.5 120.53 222.7 55.23 222.7 1.13"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "127.1 120.2 47.2 120.2 0 152.1 79.9 152.1 127.1 120.2"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "120.9 152.1 223.2 152.1 223.2 119.2 168.97 119.33 120.9 152.1"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "168.1 119.87 223.2 119.87 223.2 82.47 168.1 119.87"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M573.1,35.8h.2c4-8.8,8.9-9.8,18.3-9.8v9.7a43.5,43.5,0,0,0-5.2-.6C575.7,35.1,573,43,573,50.7v34h-9.6V27.1H573v8.7ZM520.8,52h22.9c0-16.8-4.8-18.8-11.7-18.8C526,33.2,521,36,520.8,52Zm33,7.1h-33c0,16.1,4.4,19.3,11.8,19.3,6.5,0,9.9-5.1,10.2-11h10.5c-.1,12.8-8.1,18.7-20.4,18.7S510.6,82.4,510.6,57c0-16.9,2-30.8,22.3-30.8,16.7,0,20.9,9,20.9,28.1v4.8Zm-291,25.7V2.7H251.6V84.8Zm199-24.2H451.2c-.2,7.9-.2,26.5,24.6,26.3,13.9,0,26.1-5.6,26.1-23,0-26.1-37.7-23.5-37.7-41.7,0-8.9,6.5-12.1,12.9-12.1,10.1,0,13,5.9,12.9,15h11.2C501.9,8.3,493.3,1,477.9,1c-14.1,0-24.7,7.7-24.7,22.4,0,24.8,37.7,22.7,37.7,41,0,9.8-6.5,13.4-15,13.4-6.9,0-14.1-3.5-14.1-14.7V60.6Zm-122-33.1H330v7.1h9.8V84.8h10.3V34.5h12.8V27.4H350.1V17.6c0-4.7,1.9-8.9,12.8-8.2V2.7a20.2,20.2,0,0,0-4.9-.3c-9.2,0-18.2,2.3-18.2,13.9V27.5Zm93.1,28.6c-9.8.1-22.9-.7-22.9,11.5,0,5.6,3,10.6,9.9,10.6,6.2.1,14-3.5,13-22.1Zm.2,28.7V76.5h-.2c-3.1,6.6-8,9.5-15.9,9.5-13.4,0-17.3-7.9-17.3-19,0-17.5,18.8-18.3,33.2-17.9.2-7.7.4-16-10.6-16-6.9,0-10.5,4.2-9.9,10.3H401.2c.5-12.9,8-17.3,21.4-17.3,16.3.1,20.6,7.7,20.6,17.4V71.3A89.42,89.42,0,0,0,444.4,85H433.1Zm-55.2-49V27.1H367.7V84.8h10.2v-34c0-7.8,2.9-15.6,14.2-15.6a51.36,51.36,0,0,1,5.5.6V26c-10,0-15.2,1-19.5,9.8Zm-64,49h10.3v-40c0-11.4-3.4-18.8-16.9-18.8-8.1,0-12.9,2.1-16.9,8.6h-.5V27.2H279q.6,6,.6,12V84.9h10.3V50.6c0-7.9,1.6-17,12.9-17,8.8,0,11.1,5,11.1,11.2v40ZM634.8,7,618.9,72.9h-.3L608.1,25.6H596.7l14.8,59.1h13.9L645.9,7Z",
    transform: "translate(-1.3 -1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M266.2,131.1c0-3-.5-5.6-4-5.6-4.1,0-4.1,5.6-4.1,11.8,0,10,1,11.8,4.8,11.8a9.6,9.6,0,0,0,3.3-.6v-7.1h-3.6v-4.9h10.3v16.2a69.09,69.09,0,0,1-9,1.1c-11.2,0-12.5-4.6-12.5-16.7,0-8,.4-16.2,11.3-16.2,6.5,0,10.6,3.7,10.2,10.3h-6.7Zm12.4,22V121.2H296v4.9H285.3V134h9.9v4.9h-9.9v9.3h11.1v4.9Zm22,0V121.2h9l8.5,22.1h.1V121.2h6.2v31.9h-8.8l-8.7-23.3h-.1v23.3Zm29.6-31.8h11.1c8.7,0,10.4,5.8,10.4,15.8,0,4.9.8,16.1-10.6,16.1H330.2Zm6.6,27H340c4.1,0,4.9-3,4.9-11,0-5.9,0-11-4.6-11h-3.5Zm19.8-11c0-8.4,0-16.5,11-16.5s11,8,11,16.5,0,16.5-11,16.5-11-8.2-11-16.5Zm15.3,0c0-8.2-.5-11.7-4.2-11.7s-4.2,3.5-4.2,11.7.5,11.7,4.2,11.7,4.2-3.6,4.2-11.7Zm18.5,15.9h-6.7V121.3H396c4.5,0,7.5,2.9,7.5,8.3,0,4.1-1.6,7.1-5.9,7.8v.1c1.5.2,5.8.5,5.8,6.3,0,2,.1,8,.8,9.4h-6.5c-.9-1.9-.7-4.1-.7-6.2,0-3.8.4-7-4.8-7h-1.7v13.2Zm0-18.1h3c2.6,0,3.4-2.6,3.4-4.7,0-3-1.3-4.2-3.4-4.2h-3Zm18.1,18.1V121.3H425v4.9h-9.9v8.2h9.5v4.9h-9.5v13.9Z",
    transform: "translate(-1.3 -1)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRohrgefuehrteMedienLogo);
export default __webpack_public_path__ + "static/media/RohrgefuehrteMedienLogo.4273f2c4a96381e1990fb7c4fa617dbc.svg";
export { ForwardRef as ReactComponent };